import { store } from '../../../../resources/frontend/js/store/index';

/**
 * Match the page step with the index of the steps array and return the matching step
 */
export default () => {
    const pageStep = store.state.page.step;
    const steps = store.state.page.steps;

    let currentStep = {};

    if (steps.length < pageStep) return steps[steps.length - 1];

    steps.forEach((step, index) => {
        if (index + 1 === pageStep) {
            currentStep = step;
        }
    });

    return currentStep;
};
